module.exports = __webpack_public_path__ + "img/imgTextAndImageRightSection2.ff61e175.webp";